$(document).ready(function(){
    $('.navBox__g-translate').hide();
    setTimeout(() => {
        let current_lang_code = $("#gt_float_wrapper .gt-lang-code").text();

        $('.navBox__g-translate').show();
        $("#gt_float_wrapper .gt_options").clone().appendTo('.navBox__g-translate');
        $('.navBox__g-translate .js-gt-current-lang').text(current_lang_code);
        $(".navBox__g-translate .gt_options img").each(function(){
            let img_flag_url = $(this).data("gt-lazy-src");
            $(this).attr("src", img_flag_url);
        });
    }, "2000");
    $(".js-Gtranslate-trigger").click(function(){
        $(this).next().slideToggle();
    });
    $(document).on('click', '.navBox__g-translate .nturl' , function(e){
        e.preventDefault();
        let language = $(this).data("gt-lang");
        $('.navBox__g-translate .js-gt-current-lang').text(language);
        document.querySelector(`.gt_float_switcher .nturl[data-gt-lang=${language}]`).click();
        setTimeout(() => {
            $(".navBox__g-translate .gt_options").remove();
            $("#gt_float_wrapper .gt_options").clone().appendTo('.navBox__g-translate');
            $(".navBox__g-translate .gt_options img").each(function(){
                let img_flag_url = $(this).data("gt-lazy-src");
                $(this).attr("src", img_flag_url);
            });
        }, "600"); 
    });
});